import React, { useState, useEffect } from 'react';
import { mockData } from '../mock';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ProductsSection from './ProductsSection';
import WhyChooseUsSection from './WhyChooseUsSection';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './ContactSection';
import Header from './Header';
import Footer from './Footer';

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'products', 'why-choose-us', 'testimonials', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header 
        companyName={mockData.company.name} 
        activeSection={activeSection}
        onNavigate={scrollToSection}
      />
      
      <main>
        <section id="home">
          <HeroSection data={mockData.hero} onCTAClick={() => scrollToSection('contact')} />
        </section>
        
        <section id="about">
          <AboutSection data={mockData.about} />
        </section>
        
        <section id="products">
          <ProductsSection products={mockData.products} />
        </section>
        
        <section id="why-choose-us">
          <WhyChooseUsSection reasons={mockData.whyChooseUs} />
        </section>
        
        <section id="testimonials">
          <TestimonialsSection testimonials={mockData.testimonials} />
        </section>
        
        <section id="contact">
          <ContactSection contact={mockData.company} />
        </section>
      </main>
      
      <Footer company={mockData.company} onNavigate={scrollToSection} />
    </div>
  );
};

export default LandingPage;
